module.exports = __webpack_public_path__ + "thuga_logo.jpg?5538c76db457cc94813220c931b8de89";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thuga_logo.jpg
// module id = 382
// module chunks = 0